import React from 'react';
import { connect } from 'react-redux';
import { Set } from 'immutable';
import { clearNotification } from '@/store/allaround.store';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './shortterm.css';
class ShortTermNotifications extends React.Component {
  constructor(props) {
    super(props);
    this.formNotifications = this.formNotifications.bind(this);
    this.processProp = this.processProp.bind(this);
    this.state = { notifications: new Set() };
  }

  componentDidMount() {
    this.formNotifications();
  }

  componentWillReceiveProps(props) {
    this.formNotifications(props);
  }

  formNotifications(props = this.props) {
    let notifications = new Set();
    notifications = this.processProp(props, 'dealCreated', notifications, 'Deal created');
    notifications = this.processProp(props, 'dealUpdated', notifications, 'Deal saved');
    this.setState({ notifications });
  }
  processProp(props, propName, notifications, notificationText) {
    if (props[propName] && !this.state.notifications.has(notificationText)) {
      const newNotifications = notifications.add(notificationText);
      setTimeout(() => props.clearNotification(propName), 5000);
      return newNotifications;
    }
    return notifications;
  }

  render() {
    return (<ReactCSSTransitionGroup
      transitionName="ShortTermNotification"
      transitionAppear
      transitionEnterTimeout={500} transitionLeaveTimeout={500}
    >
      {this.state.notifications.isEmpty() ?
        <div key="empty" /> :
        <div key={this.state.notifications.size} className="short-term-notification-container">
          <div className="short-term-notification">
            {this.state.notifications.map((time, text) =>
              <div style={{ padding: 5 }} key={text} >
                {text}
              </div>)}
          </div>
        </div>}
    </ReactCSSTransitionGroup>
    );
  }
}
ShortTermNotifications.propTypes = {
  dealCreated: React.PropTypes.bool,
};
export default connect(state => ({
  dealCreated: state.getIn(['allaround', 'dealCreated'], false),
  dealUpdated: state.getIn(['allaround', 'dealUpdated'], false),
}), dispatch => ({
  clearNotification(name) {
    clearNotification(dispatch, name);
  },
})
)(ShortTermNotifications);
